import type { ApplySuccessPageProps } from '@app/p/apply-success/[token]/[step]/page'
import { usePostApply } from '@components/hooks/PostApplyProvider/index.client'
import Button, { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import Modal from '@components/primitives/Modal/index.client'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'
import { trackEvent } from '@lib/tracking'
import { TrackingEvents } from '@lib/tracking/TrackingEvents'
import { useRouter } from 'next/navigation'
import { useState } from 'react'
import { getApplySuccessRouteToRedirectTo } from './getApplySuccessRouteToRedirectTo'

export const EmrConsentSkipButton = (
  props: {
    className?: string
    isDisabled?: boolean
  } & ApplySuccessPageProps,
) => {
  const [modalOpen, setModalOpen] = useState(false)
  const { advanceToNextStep } = usePostApply()
  const router = useRouter()

  return (
    <>
      <Modal
        bodyClassName='pb-4 h-full'
        className='mt-[30%] lg:mt-[10%]'
        onClose={() => setModalOpen(false)}
        size='Large'
        visible={modalOpen}
      >
        <div className='flex flex-col gap-8 rounded-lg p-4'>
          <Icon
            className='text-warning500'
            icon={faExclamationTriangle}
            size='4x'
          />
          <div className='flex flex-col items-center gap-2 text-center'>
            <Text className='text-neutral800' styleName='p-strong'>
              Are you sure?
            </Text>
            <Text className='text-neutral600'>
              Skipping this step will hurt your chances of enrollment. Giving
              consent to share your medical records is fast, and will increase
              the likelihood of a match.
            </Text>
          </div>
          <div className='flex w-full gap-2'>
            <Button
              className={classMerge(
                buttonClassNames.legacy.outline.white,
                'w-full rounded-full',
              )}
              onClick={() => {
                trackEvent(TrackingEvents.EMR_RELEASE_SECTION_SKIPPED)
                advanceToNextStep()
                router.push(
                  getApplySuccessRouteToRedirectTo(
                    'medical-release-signature',
                    props,
                  ),
                )
              }}
            >
              Skip
            </Button>
            <Button
              className={classMerge(
                buttonClassNames.legacy.fill.black,
                'w-full rounded-full border-2 border-neutral100',
              )}
              onClick={() => setModalOpen(false)}
            >
              Continue
            </Button>
          </div>
        </div>
      </Modal>
      <Button
        className={classMerge(
          buttonClassNames.legacy.accent.neutral,
          'pointer-events-auto w-full rounded-full border-2 border-neutral100 md:w-48',
          props.className,
        )}
        disabled={props.isDisabled}
        onClick={() => {
          trackEvent(TrackingEvents.EMR_RELEASE_SKIP_CLICKED)
          setModalOpen(true)
        }}
        value='Skip'
      />
    </>
  )
}
